import { Button } from "@covertree/ui";
import { Modal } from "@covertree/ui";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface Props {
  email: string;
  open: boolean;
  onClose: () => void;
}

export function EmailValidationModal({ email, open, onClose }: Props) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Email validation"
      maxWidth="sm"
      image={
        <img
          src={"/images/icons/cross.webp"}
          alt="cross"
          width="100px"
          height="100px"
        />
      }>
      <Box mb={3}>
        <Typography>
          We couldn&#39;t confidently validate the email address{" "}
          <Typography component="span" color="secondary">
            {email}
          </Typography>
          .
        </Typography>
        <Typography>
          Please make sure it&#39;s correct and submit again.
        </Typography>
      </Box>

      <Button onClick={onClose}>Ok, got it</Button>
    </Modal>
  );
}
